export const WORKSPACE_DEFAULT_WIDTH = 360;
export const WORKSPACE_MIN_WIDTH = 300;
export const WORKSPACE_MAX_WIDTH = 450;

// Horizontal padding inside the canvas container (px-2 = 8px on each side)
export const WORKSPACE_CANVAS_HORIZONTAL_PADDING = 16;
